import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setMailClose, updateEmailStatusThunk } from "../../store/features/emailsSlice";
import { updateShipmentIssue, updateShipmentStatus } from "../../store/features/shipmentsSlice";
import { PaperClipIcon, TrashIcon } from "@heroicons/react/24/outline";
import SuccessMessageBox from "../Notification/Success";
import { fetchEmailBody,sendDraftEmail } from "../../store/features/emailsSlice";

const DraftBody = ({ threadId, initialAttachments = [] }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const {shipment_id, thread_id, case_number, documents, emailBodies} = shipment;
  const currentEmail = useSelector((state) => state.emails.currentMail);
  const emailId = currentEmail?.emailId;
  const [preview, setPreview] = useState(null);
  const [body, setBody] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [subject,setSubject] = useState("");
  const [ccEmail, setCcEmail] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [attachments, setAttachments] = useState(initialAttachments); // Attachments passed in
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  useEffect(() => {
    if (!currentEmail) return;
    // Fetch email body and update state
    const fetchAndSetBody = async () => {
      try {
        const emailBody = currentEmail?.body || "";
        setBody(emailBody || ""); // Set email body
      } catch (error) {
        console.error("Failed to fetch email body:", error);
        setBody(""); // Fallback to empty body if fetch fails
      }
    };

    fetchAndSetBody();
    // setToEmail(currentEmail.to?.email || "");
    setFromEmail(currentEmail.sender || "");
    setSubject(currentEmail.subject || "")
  }, [currentEmail]);
    const handleClose = () => {
    dispatch(setMailClose());
    setToEmail("");
    setFromEmail("");
    setCcEmail("");
    setShowCC(false);
    setAttachments(initialAttachments); // Reset to initial state on close
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files).map((file) => ({
      name: file.name,
      size: file.size,
      type: file.type,
      file, // Store File object for new uploads
    }));
    setAttachments((prev) => [...prev, ...files]);
  };

  const handleRemoveAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSend = async() => {
      dispatch(
        sendDraftEmail({
          caseNumber: case_number,
          email: "supplychain@linear-works.com",
          thread_id: thread_id,
          reply_text: body,
        })
      )
        .unwrap()
        .then((response) => {
          console.log("Draft email sent successfully:", response);
        })
        .catch((error) => {
          console.error("Failed to send draft email:", error);
        });
    };

  // Function to handle preview click
  const handlePreviewClick = (file) => {
    setPreview(file);
  };

  const handleSendClick = async () => {
    try {
      setShowSuccessMessage(true);
      setTimeout(async () => {
        setShowSuccessMessage(false);
        handleClose();
        await handleSend();
        navigate(`/dashboard/cases/${shipment_id}`);
        //window.location.href = `/dashboard/cases/${shipment_id}`;
      }, 2000);
    } catch (error) {
      console.error("Failed to send email:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div className="p-6 border rounded-md h-full flex flex-col bg-white shadow">
      <div className="p-3 h-full flex flex-col overflow-auto">
        {/* Header Buttons */}
        <div className="flex justify-between items-center mb-6">
          
          <button
            onClick={handleSendClick}
            className="flex items-center gap-2 px-4 py-2 text-white bg-logo rounded hover:bg-logo-darker transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
              />
            </svg>
            Send
          </button>
        </div>

        {/* Recipients and Subject */}
        <div className="flex flex-col gap-4 mb-4 border-border-document">
          <div className="flex items-center w-full border-b border-border-document">
            <label className="font-bold mr-4 min-w-[50px]">From:</label>
            <input type="email" value={fromEmail} onChange={(e) => setFromEmail(e.target.value)}
              className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo" placeholder="Add sender" />
          </div>

          {/* <div className="flex items-center w-full border-b border-border-document">
            <label className="font-bold mr-4 min-w-[50px]">To:</label>
            <input type="email" value={toEmail} onChange={(e) => setToEmail(e.target.value)}
              className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo" placeholder="Add recipient" />
            <button onClick={() => setShowCC(!showCC)} className="text-font hover:underline ml-4">CC</button>
          </div> */}

          {/* {showCC && (
            <div className="flex items-center w-full border-b border-border-document">
              <label className="font-bold mr-4 min-w-[50px]">CC:</label>
              <input type="email" value={ccEmail} onChange={(e) => setCcEmail(e.target.value)}
                className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo" placeholder="Add CC" />
            </div>
          )} */}

          <div className="flex items-center w-full border-b border-border-document">
            <label className="font-bold mr-3 min-w-[50px]">Subject:</label>
            <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)}  className="p-1 w-full focus:outline-none focus:ring-2 focus:ring-logo" placeholder="Add a subject" />
          </div>

          {/* Attachment Upload */}
          <div className="mt-4">
            <label className="font-bold">Attachments:</label>
            <input type="file" multiple onChange={handleFileUpload} className=" ml-2 mt-2" />
            <ul className="mt-2 ">
              {attachments.map((attachment, index) => (
                <li key={index} className="flex justify-between items-center">
                <div className="flex items-center hover:text-logo" onClick={() => handlePreviewClick(attachment.url)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                  </svg>
                  {attachment.name}
                </div>
                <TrashIcon className="w-5 h-5 cursor-pointer text-red-500 ml-auto" onClick={() => handleRemoveAttachment(index)} />
              </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Preview of Attachment */}
        {preview && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-11/12 max-w-3xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Document Preview</h2>
              <button onClick={() => setPreview(null)}className="text-gray-500 rounded-full px-2 py-1 hover:bg-bg-Gray">
                &times;
              </button>
            </div>
            <iframe
              src={preview}
              title="Document Preview"
              className="w-full h-[70vh] border rounded"
            />
          </div>
        </div>
        )}

        {/* Editable Email Body */}
        <textarea
          className="flex-1 h-full p-3 rounded focus:outline-none focus:ring-2 focus:ring-logo resize-none overflow-auto text-gray-800"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Write your email here..."
          style={{ minHeight: "400px", maxHeight: "100%" }}
        />
      </div>

      {/* Success Message Popup */}
      {showSuccessMessage && <SuccessMessageBox message="Email successfully sent" />}
    </div>
  );
};

export default DraftBody;
